/*
 * @Author: your name
 * @Date: 2021-07-08 10:34:51
 * @LastEditTime: 2021-07-31 18:51:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\settlement.js
 */
export default [
    {
        path: '/settlement',
        component: resolve => require(['../../views/settlement/settlement.vue'], resolve),
        meta: { title: '结算审核' }
    },
    {
        path: '/outSystemSettlement',
        component: resolve => require(['../../views/settlement/outSystemSettlement.vue'], resolve),
        meta: { title: '系统外订单结算汇总列表' } //总部特许经营门店
    },
    {
        path: '/reconciliations',
        component: resolve => require(['../../views/settlement/reconciliations.vue'], resolve),
        meta: { title: '待对账记录' }
    },
    {
        path: '/settlementRecords',
        component: resolve => require(['../../views/settlement/settlementRecords.vue'], resolve),
        meta: { title: '结算记录' }
    },
    {
        path: '/outSystemSettlementRecords',
        component: resolve => require(['../../views/settlement/outSystemSettlementRecords.vue'], resolve),
        meta: { title: '系统外订单结算记录' }
    },    
    {
        path: '/chooseOrder',
        component: resolve => require(['../../views/settlement/chooseOrder.vue'], resolve),
        meta: { title: '选择订单' }
    },
    {
        path: '/chooseOutSystemOrder',
        component: resolve => require(['../../views/settlement/chooseOutSystemOrder.vue'], resolve),
        meta: { title: '选择系统外订单' }
    },
    {
        path: '/preview',
        component: resolve => require(['../../views/settlement/preview.vue'], resolve),
        meta: { title: '预览结算单' }
    },
    {
        path: '/previews',
        component: resolve => require(['../../views/settlement/previews.vue'], resolve),
        meta: { title: '预览结算单' }
    },
    {
        path: '/homePage',
        component: resolve => require(['../../views/homePage/homePage.vue'], resolve),
        meta: { title: '首页待办' }
    },
    {
        path: '/alarm',
        component: resolve => require(['../../views/alarm/alarm.vue'], resolve),
        meta: { title: '业务告警' }
    },
    {
        path: '/details',
        component: resolve => require(['../../views/alarm/details.vue'], resolve),
        meta: { title: '系统消息' }
    },
    {
        path: '/settlement/finalHistoryList',
        component: resolve => require(['../../views/settlement/finalHistoryList.vue'], resolve),
        meta: { title: '决算记录列表' }
    },
    {
        path: '/settlement/cashSettlementManagement',
        component: resolve => require(['../../views/settlement/cashSettlementManagement.vue'], resolve),
        meta: { title: '个人现结结算管理' }
    },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/settlement.js